import { Pipe, PipeTransform } from '@angular/core';
import { SourceSiteType } from '@services/cleanfill-api/cleanfill-api.generated';

@Pipe({
  name: 'sourceSiteType'
})
export class SourceSiteTypePipe implements PipeTransform {
  transform(value: SourceSiteType): string {
    return this.getLabel(value);
  }

  getLabel(sourceSiteType: SourceSiteType): string {
    switch (sourceSiteType) {
      case SourceSiteType.IndustrialCommercial:
        return 'Industrial / Commerical';
      case SourceSiteType.Residential:
        return 'Residential';
      case SourceSiteType.Agricultural:
        return 'Agricultural';
      case SourceSiteType.Parkland:
        return 'Parkland';
      case SourceSiteType.Community:
        return 'Community';
      case SourceSiteType.Other:
        return 'Other';
      default:
        return '';
    }
  }
}
